import { Injectable } from '@angular/core';
import { RevalidatedHttpService, RevalidatedResource } from 'src/app/core/http-cache/revalidated-http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pedidos } from './../models/pedidos'; import { BehaviorSubject } from 'rxjs';
import { PedidoSelected } from './../models/pedido';
import { BillingDetails } from './../models/billingDetails';
import { UserStore } from './../models/userStore';
import { Observable, throwError } from 'rxjs'; import { SanctumService } from 'src/app/services/sanctum.service';
import { Apps, StoreAppsResponse, StoreAppCreationResponse, StoreIntegrationResponse } from 'src/app/models/apps';
import { environment } from 'src/environments/environment';
//import 'rxjs/add/operator/map';
import { retry, catchError, shareReplay, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { IOrderListForPeriod, IRecentOrders } from '../@types/Pedidos';
import { of } from 'rxjs';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { ListCardsResponse, StripeCard } from 'src/app/models/cards';
export interface BillingHistoryLine {
  id?: string;
  description?: string | null;
  amount?: number | null;      // cents (pode ser negativo)
  quantity?: number | null;
  unit_amount?: number | null; // cents
  currency?: string | null;
  proration?: boolean | null;
  period_start?: string | null;
  period_end?: string | null;
  price_id?: string | null;
  product_id?: string | null;
}

export interface BillingHistoryRow {
  provider_invoice_id: string;
  period_label?: string | null;
  amount_cents?: number | null;
  currency?: string | null;
  status?: string | null;
  hosted_invoice_url?: string | null;
  invoice_pdf?: string | null;
  lines_summary?: BillingHistoryLine[] | string | null; // backend pode mandar string JSON
}

export interface ShopifyHistoryInfo {
  shop?: string | null;
  store_handle?: string | null;
  shopify_billing_url?: string | null;
  admin_shopify_billing_url?: string | null;
  subs_uid?: string | null;
  subs_line_item?: string | null;
  store_id?: number | null;
  message?: string | null;
}

export interface StripeHistoryInfo {
  history: BillingHistoryRow[];
  message?: string | null;
}

export interface ListHistoryResponse {
  providers: Array<'stripe' | 'shopify'>;
  shopify: ShopifyHistoryInfo | null;
  stripe: StripeHistoryInfo | null;
}


// export interface ListHistoryResponse {
//   payment_provider: 'stripe' | 'shopify';
//   history: BillingHistoryRow[];

//   shopify_billing_url?: string | null;
//   admin_shopify_billing_url?: string | null; // ✅ adicionar
//   shopify_subscriptions_url?: string | null; // se ainda quiser manter, mas recomendo não usar
// }




interface Usuario {
  user_id: number;
  user_name: string;
  user_surname: string;
  wallet_id: number;
}

interface UsuarioLP {
  name: string;
  surname: string;
  birth_date: string;
  nickname: string;
  username: string;
  phone_number: string;
  email: string;
  photo: string;
  cpf: string;
  ssn: string;
  company_name: string;
  cnpj: string;
}
interface InstPrice {
  id: number;
  name: string;
  key: string;
  cost: string;
  price: string;
  status: number;
}
interface Address {
  id: number;
  nickname: string;
  country: string;
  state: string;
  city: string;
  postal_code: string;
  address_district: string;
  address_street: string;
  address_number: string;
  address_complement: string;
}
interface Carrinho {
  shopping_cart_id: number;
  soma_items: string;
  valor_frete: string;
  total: string;
  cart_type: string;
  valor_desc_voucher_frete: string;
  valor_desc_voucher_cart: string;
  valor_desc_promo_cart: string;
  products: Produto[];
}
interface Billing {
  billing_uniq_id: string;
  billing_link: string;
  billing_id: number;
  installments_plan: Installment[];
}
interface Installment {
  n: number;
  tid: string;
  expiration_date: string;
  status: number;
  payment_link: string;
  amount: string;
}
interface Pedido {
  imagePath?: string | null;
  order: Order;
}
interface Order {
  id: number;
  store_id: number;
  shopping_cart_id: number;
  tid: string;
}
interface Produto {
  id: number;
  item_group_id: number;
  position: number;
  name: string;
  stock_qty: number;
  track_inventory: number;
  status: number;
  min_qty: number;
  inputQty: number;
  price: string;
  onsale_price: string;
  price_exchange: string;
  thumbnail: string;
  qtd: number;
}
interface Promotion {
  id: number;
  store_id: number;
  name: string;
  code: string;
  promotion_type: number;
  promotion_value_type: number;
  shopping_cart_discount: number;
  value: number;
  usage_limit: number;
  usage_qty: number;
  status: number;
}
interface IconResponse {
  data: Icon[];
  meta: Meta;
}
interface Gif {
  type: string;
  id: string;
  url: string;
  images: {
    downsized: {
      url: string;
    };
    // Inclua outras versões conforme necessário
  };
  title: string;
}

interface GifResponse {
  data: Gif[];
  meta: {

  };
  pagination: {
    total_count: number;
    last_page: number;
    per_page: number;
    current_page: number;
  };
}
interface Meta {
  pagination: Pagination;
}
interface Pagination {
  "total_count": number;
  "count": number;
  "offset": number;
}
interface Pagination {
  total: number;
  last_page: number;
  per_page: number;
  current_page: number;
}

interface Icon {
  id: number;
  name: string;
  created: string;
  slug: string;
  style: { id: number, name: string };
  family: { id: number, name: string, total: number };
  free_svg: boolean;
  author: { id: number, name: string, slug: string, avatar: string, assets: number };
  thumbnails: { width: number, height: number, url: string }[];
}

interface DeliveryMethods {
  id: number;
  method: string;
  Valor: string;
  Prazo: string;
}
interface SimulationResponseItem {
  pix?: PixData[];
  slip?: SlipData[];
  credit_card?: CreditCardData[];
}

interface PixData {
  n: number;
  charged_amount: string;
  received_amount: string;
}

interface SlipData {
  n: number;
  charged_amount: string;
  received_amount: string;
}

interface CreditCardData {
  n: number;
  charged_amount: string;
  received_amount: string;
}
//import 'rxjs/add/operator/map';

import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PedidosService {
  user: any;
  dadosUsuario: any;
  lojasUsuario: any;
  userData: any;

  id_metadata: any = 10;

  numero_loja: any = '';
  lojas: any;

  // Base url
  baseurl = `${environment.serverUrl}/admin`;
  baseurl_list = `${environment.serverUrl}`;

  constructor(
    private httpClient: HttpClient,
    private authHeaderService: AuthHeaderService,
    private http: HttpClient,
    private auth: AuthService,
    private router: Router,
    private sanctum: SanctumService,
    private revalidatedHttp: RevalidatedHttpService
  ) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
  }

  // dadosUsuarioLogado(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.auth.me().subscribe(
  //       (res) => {
  //         this.dadosUsuario = res;
  //         this.lojasUsuario = this.dadosUsuario.stores;
  //         console.log(res);
  //         console.log('dentro do service 1')
  //         this.lojasUsuario.forEach((item, index) => {
  //           console.log(item);
  //         });

  //         observer.next(this.dadosUsuario); // Emitir os dados do usuário
  //         observer.complete(); // Completar o observable
  //       },
  //       (err) => {
  //         console.log('dentro do service 2')
  //         console.log('no erro')
  //         // console.error(err);
  //         // console.log(err.status);
  //         if (err.status === 401) {
  //           console.log('Usuário não autenticado');
  //           this.router.navigate(['/login']);
  //         }

  //         observer.error(err); // Emitir o erro, se houver
  //       }
  //     );
  //   });
  // }
  setAccessToken(access_token: string, clear: Boolean = true): void {
    if (clear) {
      localStorage.clear();
    }
    localStorage.setItem("access_token", access_token);
  }
  // dadosUsuarioLogado(): Observable<any> {
  //   console.log('dentro do service 0');
  //   return this.auth.me(localStorage.getItem('access_token')).pipe();
  // }

  public getDadosLoja() {
    var id_loja;
    var lojas = this.getUser().stores;

    if (environment.production) {
      return this.httpClient.get(`${environment.serverUrl}/admin/show_stores/${id_loja}`,
        this.httpOptions
      );
    } else {
      return this.httpClient.get(`${environment.paymentGenetatorLinkURL}/admin/show_stores/${id_loja}`,
        this.httpOptions
      ).pipe();

    }
  }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.getAccessToken()}`,
    }),
  };

  detailPedido(id: any): Promise<any> {
    if (environment.production) {
      return this.http
        .get(`${environment.serverUrl}/admin/show_stores/${id}`, this.httpOptions)
        .toPromise();
    } else {
      return this.http
        .get(`${environment.paymentGenetatorLinkURL}/admin/show_stores/${id}`, this.httpOptions)
        .toPromise();
    }

  }

  // GET PEDIDOS/VENDAS
  listarPedidosVendasStore(
    payment_status: number,
    data1?: any,
    data2?: any,
    user_id?: number,
    match_mode_user_id?: string,
    user_name?: string,
    match_mode_user_name?: string,
    user_cpf?: string,
    match_mode_user_cpf?: string,
    forma_pagamento?: number,
    forma_entrega?: number
  ): Observable<IOrderListForPeriod> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    // Inicializando queryParam com o parâmetro obrigatório
    let queryParam = '?payment_status=' + payment_status;

    const isValidDate = (date: any) => {
      return date instanceof Date && !isNaN(date.valueOf());
    }
    // Adicionando condicionalmente os outros parâmetros
    console.log('data1' + data1)
    if (isValidDate(new Date(data1)) && data1 != null) {
      queryParam += '&date_from=' + new Date(data1).toISOString().split('T')[0];
    }
    if (isValidDate(new Date(data2))) {
      queryParam += '&date_to=' + new Date(data2).toISOString().split('T')[0];
    }
    // Continuando com os outros parâmetros
    if (user_id) {
      queryParam += '&user_id=' + user_id + '&match_mode_user_id=' + match_mode_user_id;
    }
    if (user_name) {
      queryParam += '&user_name=' + encodeURIComponent(user_name) + '&match_mode_user_name=' + match_mode_user_name;  // Encode para URL
    }
    if (user_cpf) {
      queryParam += '&user_cpf=' + user_cpf + '&match_mode_user_cpf=' + match_mode_user_cpf;
    }
    if (forma_pagamento) {
      queryParam += '&forma_pagamento=' + forma_pagamento;
    }
    if (forma_entrega) {
      queryParam += '&forma_entrega=' + forma_entrega;
    }

    queryParam += '&data=asc';

    if (environment.production) {
      return this.http
        .get<IOrderListForPeriod>(
          `${environment.serverUrl}/admin/store/${id_loja}/order/list` + queryParam,
          this.httpOptions
        )
        .pipe(retry(1));


    } else {
      return this.http
        .get<IOrderListForPeriod>(
          `${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/order/list` + queryParam,
          this.httpOptions
        )
        .pipe(retry(1));
    }



  }

  // BUSCAR Pedidos
  public GetPedidosByUser(user_id: number) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getAccessToken()}`,
      }),
    };
    var id_loja;
    var lojas = this.getUser().stores;

    // lojas.forEach((item, index) => {
    //   id_loja = item.store_id;
    // });

    let url;
    if (environment.production) {
      url = `${environment.serverUrl}/shop/store/${id_loja}/order/user/${user_id}`;
    } else {
      url = `${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/order/user/${user_id}`;
    }

    return this.httpClient.get(url, this.httpOptions).pipe();
  }

  // BUSCAR Pedidos
  public GetPedidosPorParmeters(page: number, rows: number, filters: any = {}) {
    // Configurações iniciais de cabeçalhos HTTP
    // É uma boa prática criar uma função separada para obter os cabeçalhos HTTP,
    // especialmente se você os usa em vários métodos.
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,  // Assegure-se de que getAccessToken está retornando o token esperado.
      }),
    };

    // Obter o ID da loja de armazenamento local ou definir como vazio se não encontrado
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    // Monta a URL com os parâmetros de paginação
    let url = `${environment.serverUrl}/shop/store/${id_loja}/order?page=${page}&limit=${rows}`;

    // Monta os parâmetros de filtro
    let filterParams = new HttpParams();
    for (let key in filters) {
      // Verifique se o filtro existe e tem um valor.
      if (filters[key] && filters[key].value) {
        // Inclui o valor do filtro
        filterParams = filterParams.append(`filters[${key}][value]`, filters[key].value);

        // Inclui o matchMode do filtro
        if (filters[key].matchMode) {
          filterParams = filterParams.append(`filters[${key}][matchMode]`, filters[key].matchMode);
        }
      }
    }

    // Faz a requisição HTTP GET com os cabeçalhos e parâmetros
    return this.httpClient.get(url, {
      headers: httpOptions.headers,
      params: filterParams // Inclui os parâmetros de filtro na requisição
    }).pipe(
      // Adicione operadores RxJS conforme necessário, por exemplo, catchError para tratar erros.
    );
  }


  // BUSCAR Pedidos
  public GetPedidos() {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getAccessToken()}`,
      }),
    };
    var id_loja;
    var lojas = this.getUser().stores;

    if (environment.production) {
      return this.httpClient.get(
        `${environment.serverUrl}/shop/store/${id_loja}/orders/list?date=desc`,
        this.httpOptions
      );



    } else {
      return this.httpClient.get(
        `${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/order?date=desc`,
        this.httpOptions
      );


    }
  }

  // BUSCAR Pedidos Receitas
  public GetPedidosReceitas() {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getAccessToken()}`,
      }),
    };
    var id_loja;
    var lojas = this.getUser().stores;

    // lojas.forEach((item, index) => {
    //   id_loja = item.store_id;
    // });

    if (environment.production) {
      return this.httpClient.get(`${environment.serverUrl}/shop/store/${id_loja}/order/store_customers?payment_status=2&status=1`,
        this.httpOptions
      ).pipe(

      );
    } else {
      return this.httpClient.get(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/order/store_customers?payment_status=2&status=1`,
        this.httpOptions
      ).pipe();
    }
  }

  // BUSCAR Últimos Pedidos
  public GetUltimosPedidos(): Observable<IRecentOrders> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getAccessToken()}`,
      }),
    };
    var id_loja;
    var lojas = this.getUser().stores;

    // lojas.forEach((item, index) => {
    //   id_loja = item.store_id;
    // });


    //baseurl_list = `${environment.serverUrl}`;
    if (environment.production) {
      return this.httpClient.get<IRecentOrders>(
        `${environment.serverUrl}/shop/store/${id_loja}/order?limit=10&payment_status=2&status=1&date=desc`,
        this.httpOptions
      ).pipe();

    } else {
      return this.httpClient.get<IRecentOrders>(
        `${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/order?limit=10&payment_status=2&status=1&date=desc`,
        this.httpOptions
      ).pipe();
    }


  }

  calcCartId(id_carrinho: number): Observable<Carrinho> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/${id_carrinho}/calc`,
          null,
          this.httpOptions
        )
        .pipe(catchError(error => {
          return of(error);
        }));
    } else {
      return this.http
        .patch<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/${id_carrinho}/calc`,
          null,
          this.httpOptions
        )
        .pipe(catchError(error => {
          return of(error);
        }));
    }
  }
  deatilCartId(id_carrinho: number): Observable<Carrinho> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .get<Carrinho>(`${environment.serverUrl}/shop/shoppingcart?shopping_cart_id=${id_carrinho}`,
          this.httpOptions
        )
        .pipe(catchError(error => {
          return of(error);
        }));
    } else {
      return this.http
        .get<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/shoppingcart?shopping_cart_id=${id_carrinho}`,
          this.httpOptions
        )
        .pipe(catchError(error => {
          return of(error);
        }));
    }
  }
  /// 
  createOrder(data: any): Observable<Pedido> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .post<Pedido>(`${environment.serverUrl}/admin/store/${id_loja}/order/create`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    } else {
      return this.http
        .post<Pedido>(`${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/order/create`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    }

  }
  updateOrder(data: any, order_id: number | null): Observable<Pedido> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Pedido>(`${environment.serverUrl}/admin/store/${id_loja}/order/${order_id}`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    } else {
      return this.http
        .patch<Pedido>(`${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/order/${order_id}`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    }

  }
  updateLinkRas(data: any, order_id: number | null): Observable<Pedido> {  ///billings/{billing}/address/{walletAddress}
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Pedido>(`${environment.serverUrl}/admin/store/${id_loja}/order_tracker/${order_id}`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    } else {
      return this.http
        .patch<Pedido>(`${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/order_tracker/${order_id}`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    }

  }
  updateAddress(billing_id: number, wallet_address_id: number): Observable<Pedido> {  ///billings/{billing}/address/{walletAddress}
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Pedido>(`${environment.serverUrl}/billings/${billing_id}/address/${wallet_address_id}`,
          null,
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    } else {
      return this.http
        .patch<Pedido>(`${environment.paymentGenetatorLinkURL}/billings/${billing_id}/address/${wallet_address_id}`,
          null,
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    }

  }
  updateOrderInvoice(data: any, order_id: number | null): Observable<Pedido> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Pedido>(`${environment.serverUrl}/admin/store/${id_loja}/order_invoice/${order_id}`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    } else {
      return this.http
        .patch<Pedido>(`${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/order_invoice/${order_id}`,
          JSON.stringify(data),
          httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    }

  }

  AdicionarItem(data: any, id_carrinho: number, id_produto: number): Observable<Carrinho> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .post<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/add_product/' + id_produto,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          const mensagemErro = error.error.message || 'Erro desconhecido';
          return throwError(() => new Error(mensagemErro));
        }));
    } else {
      return this.http
        .post<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/add_product/' + id_produto,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          const mensagemErro = error.error.message || 'Erro desconhecido';
          return throwError(() => new Error(mensagemErro));
        }));
    }

  }

  detalharLP(billing_uniq_id: string): Observable<Billing> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .get<Billing>(`${environment.serverUrl}/billings/billing_group/${billing_uniq_id}`,
          this.httpOptions
        )
        .pipe(catchError(error => {
          const mensagemErro = error.error.message || 'Erro desconhecido';
          return throwError(() => new Error(mensagemErro));
        }));
    } else {
      return this.http
        .get<Billing>(`${environment.paymentGenetatorLinkURL}/billings/billing_group/${billing_uniq_id}`,
          this.httpOptions
        )
        .pipe(catchError(error => {
          const mensagemErro = error.error.message || 'Erro desconhecido';
          return throwError(() => new Error(mensagemErro));
        }));
    }

  }
  async login(email: string, pass: string): Promise<Observable<any>> {
    await this.sanctum.initSanctum();

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/auth/login`;

    const body = { email, password: pass };

    const httpOptions = await this.authHeaderService.getHttpOptions(); // ✅ fixado aqui

    return this.http.post<any>(url, body, httpOptions).pipe(
      catchError(error => {
        console.error('Erro no login:', error);
        return throwError(() => error);
      })
    );
  }
  verifyPassword(password: string): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/auth/verify-password`;
    const body = { password };

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(options => this.http.post<any>(url, body, options)),
      catchError(error => {
        console.error('Erro ao verificar senha:', error);
        return throwError(() => error);
      })
    );
  }




  async changePassword(data: any): Promise<Observable<any>> {
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const user_id = localStorage.getItem("user_id") || '';
    const url = `${environment.apiBaseUrl}/api/users/${user_id}/changepass`;

    return this.http.post<any>(url, data, httpOptions).pipe(
      catchError(error => throwError(error))
    );
  }

  // Cache-first com ETag.
  countSlicksRevalidated(): RevalidatedResource<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/countslicks`;
    const cacheKey = `countslicks:store:${storeId}`;

    return this.revalidatedHttp.getSignal<any>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  async countSlicks(): Promise<Observable<any>> {
    //await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/countslicks`;

    return this.http.get<any>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao contar slicks:', error);
        return throwError(() => error);
      })
    );
  }



  // Cache-first com ETag.
  plansRevalidated(): RevalidatedResource<any> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/plans`;
    const cacheKey = `plans:store:${storeId}`;

    return this.revalidatedHttp.getSignal<any>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  async plans(): Promise<Observable<any>> {
    //await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/plans`;

    return this.http.get<any>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao buscar os planos:', error);
        return throwError(() => error);
      })
    );
  }


  async finalizeSubscription(paymentIntentId: string): Promise<Observable<any>> {
    await this.sanctum.initSanctum();
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;
    const baseUrl = `${environment.apiBaseUrl}/api`;
    return this.http.post<any>(
      `${baseUrl}/admin/store/${storeId}/finalizeSubscription`,
      { payment_intent_id: paymentIntentId },
      httpOptions
    ).pipe(catchError(error => throwError(() => error)));
  }

  async createSubscription(payload: any): Promise<Observable<any>> {
    await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/createSubscription`;

    return this.http.post<any>(url, payload, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao criar a assinatura Shopify:', error);
        return throwError(() => error);
      })
    );
  }

  // pedidos.service.ts (ou um StripeCardsService)
  async createCardSetupIntent(): Promise<Observable<any>> {
    await this.sanctum.initSanctum();
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const user_id = Number(localStorage.getItem('user_id')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    return this.http.post<any>(
      `${baseUrl}/admin/user/${user_id}/stripe/cards/setup-intent`,
      {},
      httpOptions
    );
  }

  async setDefaultCard(paymentMethodId: string, customerId: string | null): Promise<Observable<any>> {
    await this.sanctum.initSanctum();
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const user_id = Number(localStorage.getItem('user_id')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    return this.http.post<any>(
      `${baseUrl}/admin/user/${user_id}/stripe/cards/set-default`,
      { payment_method_id: paymentMethodId, customer_id: customerId },
      httpOptions
    );
  }
  async attachCard(paymentMethodId: string, customerId: string | null): Promise<Observable<any>> {
    await this.sanctum.initSanctum();
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const user_id = Number(localStorage.getItem('user_id')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    return this.http.post<any>(
      `${baseUrl}/admin/user/${user_id}/stripe/cards/attach`,
      { payment_method_id: paymentMethodId, customer_id: customerId },
      httpOptions
    );
  }




  async cancelShopifySubscription(): Promise<Observable<any>> {
    await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/cancelShopifySubscription`;

    return this.http.post<any>(url, {}, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao cancelar a assinatura Shopify:', error);
        return throwError(() => error);
      })
    );
  }


  private cachedUser$: Observable<UsuarioLP> | null = null;

  getCachedUserDetail(user_id: number, forceRefresh = false): Observable<UsuarioLP> {
    const cacheKey = `user_detail_${user_id}`;

    if (!forceRefresh) {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          return of(parsed);
        } catch {
          // erro no parse, segue com request
        }
      }
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${user_id}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<UsuarioLP>(url, httpOptions).pipe(
          tap(user => {
            localStorage.setItem(cacheKey, JSON.stringify(user));
          })
        )
      ),
      catchError(err => throwError(() => err))
    );
  }


  getPushNotificationsForUser(userId: number, page = 1, limit = 5): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/all_pushs`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.post<any>(
          url,
          { page, limit },
          httpOptions
        )
      )
    );
  }

  getUserMessages(userId: number, page = 1, limit = 10, search = ''): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/messages`;

    const body: any = { page, limit };
    if (search) body.search = search;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>( // GET para seguir o padrão REST (pode mudar para POST se o backend exigir)
          url,
          {
            params: body,
            ...httpOptions
          }
        )
      )
    );
  }

  // Cache-first com ETag (src/app/core/http-cache).
  getUserMessagesRevalidated(userId: number, page = 1, limit = 10, search = ''): RevalidatedResource<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/messages`;

    const params: any = { page, limit };
    if (search) params.search = search;

    const cacheKey = `user_messages:${userId}:${page}:${limit}:${search}`;

    return this.revalidatedHttp.getSignal<any>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions(),
      { params }
    );
  }



  getUnreadPushCount(userId: number): Observable<{ unread_count: number }> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/unread_pushs`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<{ unread_count: number }>(url, httpOptions)
      ),
      catchError(err => throwError(() => err))
    );
  }

  // Cache-first com ETag (src/app/core/http-cache). Não usar em
  // refreshUnreadPushCount() (reage a evento de push em tempo real via
  // websocket) — lá o valor precisa vir sempre fresco da rede.
  getUnreadPushCountRevalidated(userId: number): RevalidatedResource<{ unread_count: number }> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/unread_pushs`;
    const cacheKey = `unread_pushs:${userId}`;

    return this.revalidatedHttp.getSignal<{ unread_count: number }>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  markPushAsRead(userId: number, notificationId: number): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/pushs/${notificationId}/read`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions => this.http.patch(url, {}, httpOptions)),
      catchError(err => throwError(() => err))
    );
  }

  markMessageAsRead(userId: number, messageId: number): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${userId}/messages/${messageId}/read`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions => this.http.patch(url, {}, httpOptions)),
      catchError(err => throwError(() => err))
    );
  }


  private unreadPushCount$ = new BehaviorSubject<number>(0);

  setUnreadPushCount(count: number): void {
    this.unreadPushCount$.next(count);
  }

  getCurrentUnreadPushCount(): number {
    return this.unreadPushCount$.value;
  }


  getUnreadPushCountObservable(): Observable<number> {
    return this.unreadPushCount$.asObservable();
  }

  refreshUnreadPushCount(userId: number): void {
    this.getUnreadPushCount(userId).subscribe({
      next: res => this.setUnreadPushCount(res.unread_count || 0),
      error: err => console.error('Erro ao atualizar contador de pushs não lidos:', err)
    });
  }



  // Cache-first com ETag (src/app/core/http-cache).
  detailUserRevalidated(user_id: number): RevalidatedResource<UsuarioLP> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/${user_id}`;
    const cacheKey = `user_detail:id:${user_id}`;

    return this.revalidatedHttp.getSignal<UsuarioLP>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  async detailUser(user_id: number): Promise<Observable<UsuarioLP>> {
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const baseUrl = `${environment.apiBaseUrl}/api`; // ✅ obrigatório

    const url = `${baseUrl}/users/${user_id}`;

    return this.http.get<UsuarioLP>(url, httpOptions).pipe(
      catchError(error => throwError(() => error))
    );
  }

  async saveUser(user_id: number, data: any): Promise<Observable<UsuarioLP>> {
    await this.sanctum.initSanctum(); // Necessário para CSRF em SPA

    const httpOptions = await this.authHeaderService.getHttpOptions();

    const url = `${environment.apiBaseUrl}/api/users/${user_id}`;

    return this.http.patch<UsuarioLP>(url, data, httpOptions).pipe(
      catchError(error => throwError(error))
    );
  }


  forgot(email: string): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/auth/forgot`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, { email }, httpOptions).pipe(
              catchError(error => {
                console.error('Erro ao solicitar recuperação de senha:', error);
                return throwError(() => error);
              })
            )
          )
        )
      )
    );
  }

  async changeEmail(data: any, user_id: number): Promise<Observable<UsuarioLP>> {
    await this.sanctum.initSanctum(); // necessário para CSRF

    const httpOptions = await this.authHeaderService.getHttpOptions();

    const url = `${environment.apiBaseUrl}/api/users/change_email/${user_id}`;

    return this.http.post<UsuarioLP>(url, data, httpOptions).pipe(
      catchError(error => throwError(error))
    );
  }

  createLP(data: any): Observable<Billing> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .post<Billing>(`${environment.serverUrl}/billings/billing_group_link`,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    } else {
      return this.http
        .post<Billing>(`${environment.paymentGenetatorLinkURL}/billings/billing_group_link`,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => throwError(error)));
    }

  }
  detailLP(billing_uniq_id: string): Observable<Billing> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .get<Billing>(`${environment.serverUrl}/billings/billing_group/${billing_uniq_id}`,
          httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    } else {
      return this.http
        .get<Billing>(`${environment.paymentGenetatorLinkURL}/billings/billing_group/${billing_uniq_id}`,
          httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    }

  }
  // REMOVE ITEM
  removerItem(data: any, id_carrinho: number, id_produto: number): Observable<Carrinho> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/remove_product/' + id_produto,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    } else {
      return this.http
        .patch<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/remove_product/' + id_produto,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    }

  }
  // valor_desc_voucher_frete + valor_desc_voucher_cart
  // valor_desc_promo_cart
  aplicarCupom(data: string, id_carrinho: number): Observable<Carrinho> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/voucher?name=' + data,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          const mensagemErro = error.error.message || 'Erro desconhecido';
          return throwError(() => new Error(mensagemErro));
        }));
    } else {
      return this.http
        .patch<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/voucher?name=' + data,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          const mensagemErro = error.error.message || 'Erro desconhecido';
          return throwError(() => new Error(mensagemErro));
        }));
    }

  }
  removerCupom(id_carrinho: number): Observable<Carrinho> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .patch<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/remove_voucher',
          null,
          this.httpOptions
        )
        .pipe(catchError(error => {
          return throwError(() => new Error(error));
        }));
    } else {
      return this.http
        .patch<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/` + id_carrinho + '/remove_voucher',
          null,
          this.httpOptions
        )
        .pipe(catchError(error => {
          return throwError(() => new Error(error));
        }));
    }

  }
  async billingPortal(user_id: number): Promise<Observable<{ portal_url: string }>> {
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/user/${user_id}/billing_portal`;

    return this.http.get<{ portal_url: string }>(url, httpOptions).pipe(
      catchError(error => throwError(() => error))
    );
  }

  async removeCard(user_id: number, paymentMethodId: string): Promise<Observable<any>> {
    await this.sanctum.initSanctum();
    const httpOptions = await this.authHeaderService.getHttpOptions();

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/user/${user_id}/cards/${paymentMethodId}`;

    return this.http.delete<any>(url, httpOptions).pipe(
      catchError(error => throwError(() => error))
    );
  }


  // Cache-first com ETag.
  listCardsRevalidated(user_id: number): RevalidatedResource<ListCardsResponse> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/user/${user_id}/stripe/cards`;
    const cacheKey = `stripe_cards:user:${user_id}`;

    return this.revalidatedHttp.getSignal<ListCardsResponse>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  async listCards(user_id: number): Promise<Observable<ListCardsResponse>> {
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/user/${user_id}/stripe/cards`;

    return this.http.get<ListCardsResponse>(url, httpOptions).pipe(
      catchError(error => throwError(() => error))
    );
  }
  // Cache-first com ETag.
  listHistoryRevalidated(user_id: number): RevalidatedResource<ListHistoryResponse> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/user/${user_id}/list_history`;
    const cacheKey = `list_history:user:${user_id}`;

    return this.revalidatedHttp.getSignal<ListHistoryResponse>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  async listHistory(user_id: number): Promise<Observable<ListHistoryResponse>> {
    const httpOptions = await this.authHeaderService.getHttpOptions();
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/user/${user_id}/list_history`;

    return this.http.get<ListHistoryResponse>(url, httpOptions).pipe(
      catchError(error => throwError(() => error))
    );
  }
  async listProducts(cursor?: string | null, search?: string | null): Promise<Observable<{ products: any[], page_info: any }>> {
    const httpOptions = await this.authHeaderService.getPublicHttpOptions();

    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    const store_id = Number(selectedStoreId);

    const urlBase = `${environment.apiBaseUrl}/api`;

    const url = `${urlBase}/public/admin/store/${store_id}/show_products`;

    let params = new HttpParams();
    if (cursor) params = params.set('cursor', cursor);
    if (search) params = params.set('search', search);

    const finalOptions = {
      ...httpOptions,
      params
    };

    return this.http.get<{ products: any[], page_info: any }>(url, finalOptions).pipe(
      catchError((error) => {
        console.error('Erro ao buscar produtos:', error);
        return throwError(() => error);
      })
    );
  }



  getAppsStore(key?: string): Observable<StoreAppsResponse> {
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    const store_id = selectedStoreId ? Number(selectedStoreId) : null;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/admin/store/${store_id}/store_apps`;
    if (key) {
      url += `?key=${encodeURIComponent(key)}`;
    }

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<StoreAppsResponse>(url, httpOptions).pipe(
          catchError(error => {
            console.error('Erro ao buscar apps:', error);
            return throwError(() => error);
          })
        )
      )
    );
  }


  getStoreIntegration(storeKey?: string): Observable<StoreIntegrationResponse> {
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    const store_id = selectedStoreId ? Number(selectedStoreId) : null;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/admin/store/${store_id}/store_app`;
    if (storeKey) {
      url += `?store=${encodeURIComponent(storeKey)}`;
    }

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<StoreIntegrationResponse>(url, httpOptions).pipe(
          catchError(error => {
            console.error('Erro ao buscar integração da loja:', error);
            return throwError(() => error);
          })
        )
      )
    );
  }

  // Cache-first com ETag.
  getStoreIntegrationRevalidated(storeKey?: string): RevalidatedResource<StoreIntegrationResponse> {
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    const store_id = selectedStoreId ? Number(selectedStoreId) : null;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/admin/store/${store_id}/store_app`;
    if (storeKey) {
      url += `?store=${encodeURIComponent(storeKey)}`;
    }

    const cacheKey = `store_integration:store:${store_id}:key:${storeKey || ''}`;

    return this.revalidatedHttp.getSignal<StoreIntegrationResponse>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  getTodosProdutos(): Observable<Produto[]> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const url = `${baseUrl}/shop/store/${storeId}/product_boosted?parent_sku=1`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<Produto[]>(url, httpOptions).pipe(
          catchError(error => {
            console.error('Erro ao buscar produtos boostados:', error);
            return throwError(() => error);
          })
        )
      )
    );
  }

  GetPromotions(): Observable<Promotion[]> {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (environment.production) {
      return this.http
        .get<Promotion>(`${environment.serverUrl}/admin/store/${id_loja}/promotions`,
          httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    } else {
      return this.http
        .get<Promotion>(`${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/promotions`,
          httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    }

  }
  addShippingMethodToCart(data: any, shopping_cart_id: number): Observable<Carrinho> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .patch<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/${shopping_cart_id}/shipping_method`,
          data,
          this.httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    } else {
      return this.http
        .patch<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/${shopping_cart_id}/shipping_method`,
          data,
          this.httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    }

  }
  simularVenda(data: any): Observable<SimulationResponseItem[]> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http.post<SimulationResponseItem[]>(`${environment.serverUrl}/billings/billing_group_simulate`, JSON.stringify(data), this.httpOptions)
        .pipe(catchError(error => of(error)));
    } else {
      return this.http.post<SimulationResponseItem[]>(`${environment.paymentGenetatorLinkURL}/billings/billing_group_simulate`, JSON.stringify(data), this.httpOptions)
        .pipe(catchError(error => of(error)));
    }

  }
  addZipCodeToCart(data: any, shopping_cart_id: number): Observable<Carrinho> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .patch<Carrinho>(`${environment.serverUrl}/shop/store/${id_loja}/shoppingcart/${shopping_cart_id}/zipcode`,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    } else {
      return this.http
        .patch<Carrinho>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shoppingcart/${shopping_cart_id}/zipcode`,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe(catchError(error => {
          // Aqui você pode tratar o erro ou apenas reemitir
          return of(error); // Reemite o erro como um valor observável
        }));
    }

  }
  listDeliveryAddress(data: any, shopping_cart_id: number): Observable<DeliveryMethods[]> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    const url = environment.production
      ? `${environment.serverUrl}/shop/store/${id_loja}/shipping_methods`
      : `${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/shipping_methods`;

    return this.http
      .post<DeliveryMethods | DeliveryMethods[]>(url, data, this.httpOptions)
      .pipe(
        map(response => Array.isArray(response) ? response : [response]), // Assegura que o retorno seja sempre um array
        catchError(error => {
          let errorMessage = error.error?.message || 'Erro desconhecido';
          return throwError(() => new Error(errorMessage));
        })
      );
  }

  gerarSessaoVisitante(data: any): Observable<Carrinho> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    return this.http
      .post<Carrinho>(`${environment.apiBaseUrl}/api/public/store/${id_loja}/guest_auth`,
        JSON.stringify(data),
        this.httpOptions
      )
      .pipe();

  }
  installmentInterest(data: any): Observable<InstPrice[]> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .post<InstPrice[]>(`${environment.serverUrl}/pricing/price`,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe();
    } else {
      return this.http
        .post<InstPrice[]>(`${environment.paymentGenetatorLinkURL}/pricing/price`,
          JSON.stringify(data),
          this.httpOptions
        )
        .pipe();
    }

  }
  // Listar users vinculados 
  GetUsuariosVinculadosLoja(): Observable<Usuario[]> {


    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    return this.httpClient.get<Usuario[]>(`${environment.apiBaseUrl}/api/auth/store/${id_loja}/store_customer`, this.httpOptions);
  }
  getUserAddress(wallet_id: number): Observable<Address[]> {

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.httpClient.get<Address[]>(`${environment.serverUrl}/wallets/${wallet_id}/addresses`, this.httpOptions);
    } else {
      return this.httpClient.get<Address[]>(`${environment.paymentGenetatorLinkURL}/wallets/${wallet_id}/addresses`, this.httpOptions);
    }
  }

  detailOrder(id: number): Observable<PedidoSelected> { // sss PedidoSelected
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .get<PedidoSelected>(`${environment.serverUrl}/shop/store/${id_loja}/order/${id}`, this.httpOptions)
        .pipe(retry(1));
    } else {
      return this.http
        .get<PedidoSelected>(`${environment.paymentGenetatorLinkURL}/shop/store/${id_loja}/order/${id}`, this.httpOptions)
        .pipe(retry(1));
    }
  }
  detailBilling(tid: string): Observable<BillingDetails> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .get<BillingDetails>(`${environment.serverUrl}/billings/billing_details/${tid}`, this.httpOptions)
        .pipe(retry(1));
    } else {
      return this.http
        .get<BillingDetails>(`${environment.paymentGenetatorLinkURL}/billings/billing_details/${tid}`, this.httpOptions)
        .pipe(retry(1));
    }
  }


  detailUserFromStore(id: number): Observable<UserStore[]> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .get<UserStore[]>(`${environment.serverUrl}/auth/store/${id_loja}/store_user/user/${id}`, this.httpOptions)
        .pipe(retry(1));
    } else {
      return this.http
        .get<UserStore[]>(`${environment.paymentGenetatorLinkURL}/auth/store/${id_loja}/store_user/user/${id}`, this.httpOptions)
        .pipe(retry(1));
    }
  }
  // DELETE
  DeletePedido(id: any) {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };

    if (environment.production) {
      return this.http
        .delete<Pedidos>(`${environment.serverUrl}/admin/store/${id_loja}/order/${id}`, this.httpOptions)
        .pipe(retry(1));
    } else {
      return this.http
        .delete<Pedidos>(`${environment.paymentGenetatorLinkURL}/admin/store/${id_loja}/order/${id}`, this.httpOptions)
        .pipe(retry(1));
    }
  }



  async searchIcons(
    query: string,
    first: number = 0,
    rows: number = 96,
    color: string | null = '',
    shape: string = ''
  ): Promise<Observable<IconResponse>> {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/search-icons?query=${encodeURIComponent(query)}&first=${first}&limit=${rows}&color=${color}&shape=${shape}`;

    const httpOptions = await this.authHeaderService.getHttpOptions();

    return this.http.get<IconResponse>(url, httpOptions);
  }

  async searchGifs(query: string, first: number = 0, rows: number = 20): Promise<Observable<GifResponse>> {
    //await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();

    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/search-gifs?query=${encodeURIComponent(query)}&first=${first}&limit=${rows}`;

    return this.http.get<GifResponse>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao buscar GIFs:', error);
        return throwError(() => error);
      })
    );
  }

  getAccessToken(): string {
    return localStorage.getItem('access_token') || '';
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem('user') || '');
  }
}
